import { DosageTemplate } from '@dreryk/egabinet-prescription-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { ExtendedDosageStagesList } from '~libs.desktop.shared.medicine';

import { extendedDosageTemplatesTranslationKeys, prescriptionTranslationKeys } from '../../../../../translations';

import { StyledDosageTemplateReadOnly } from './DosageTemplateReadOnly.styled';

type DosageTemplateReadOnlyProps = {
   readonly item: DosageTemplate;
};

export const DosageTemplateReadOnly = (props: DosageTemplateReadOnlyProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledDosageTemplateReadOnly direction={'column'} gap={'24px'}>
         <TextView testId={'templateName'} label={extendedDosageTemplatesTranslationKeys.templateName}>
            <>{props.item.name}</>
         </TextView>
         <TextView testId={'extendedDosage'} label={prescriptionTranslationKeys.dosage.extendedDosage}>
            <ExtendedDosageStagesList
               stages={props.item.extendedDosage.stages}
               portionUnit={translate(extendedDosageTemplatesTranslationKeys.portionUnitPlaceholder)}
            />
         </TextView>
      </StyledDosageTemplateReadOnly>
   );
};
